import React from 'react';

import {BatchSummary} from 'constants/SampleConstants';
import {SearchContext} from 'search/SearchConstants';
import ItemSearchInput from 'ui-library/attach-dropdown/ItemSearchInput';
import {deprecatedSearchGet} from 'ui-library/inputs/ChipSearchInput';
import {ElementKeyboardEvent} from 'util/Types';

export interface BatchSearchInputProps {
  autoFocus?: boolean;
  batchSchemaId?: string | null;
  onChange: (batches: Array<BatchSummary>) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  isReadOnly?: boolean;
  selectedBatches: Array<{id: string | null}>;
  shouldAllowMultiple?: boolean;
  hideSelectedResults?: boolean;
  context?: SearchContext;
}

export default function BatchSearchInput(props: BatchSearchInputProps): JSX.Element {
  const fetchParams = {
    context: props.context,
  };
  return (
    <ItemSearchInput
      autoFocus={props.autoFocus}
      fetchParams={fetchParams}
      doSearch={deprecatedSearchGet}
      itemKey="samples"
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
      placeholder="Search for batch"
      isReadOnly={props.isReadOnly}
      searchURL="/1/api/batches/search"
      selectedItems={props.selectedBatches}
      shouldAllowMultiple={props.shouldAllowMultiple}
      hideSelectedResults={props.hideSelectedResults}
    />
  );
}

BatchSearchInput.defaultProps = {
  autoFocus: false,
  isReadOnly: false,
};
